module.exports = "/images/lojaintegrada.png?f9e8e97d1596968c92f6f56f7620a244";